import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Root } from './Footnote.styles';
export const Footnote = ({ children, className, color, index })=>/*#__PURE__*/ _jsxs(Root, {
        $color: color,
        className: className,
        renderAs: 'div',
        size: "Xs",
        children: [
            /*#__PURE__*/ _jsx("sup", {
                children: index
            }),
            children
        ]
    });

//# sourceMappingURL=Footnote.js.map